import { render, staticRenderFns } from "./AccountUserAddresses.vue?vue&type=template&id=e6934510"
import script from "./AccountUserAddresses.vue?vue&type=script&lang=js"
export * from "./AccountUserAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports